import { createContext, FC, useMemo } from 'react'
import { useImmer } from 'use-immer'

export interface SessionProps {
  name: string
  path: string
  loading: boolean
}

export interface SessionsProps {
  sessions: SessionProps[]
  hasSessions: boolean
  unregister: (name: string) => void
  register: (attrs: SessionProps) => void
}

const SessionsProvider: FC = ({ children }) => {
  const [sessions, updateSessions] = useImmer<SessionProps[]>([])

  const hasSessions = useMemo(() => sessions.length > 0, [sessions])

  const register = ({ name, path, loading }: SessionProps) => {
    const alreadyRegistered = sessions.find(session => session.name === name)

    if (alreadyRegistered) {
      const index = sessions.findIndex(session => session.name === name)

      updateSessions(draft => {
        draft[index].loading = loading
      })

      return
    }

    updateSessions(draft => {
      draft.push({ name, path, loading })
    })
  }

  const unregister = (name: string) => {
    const session = sessions.findIndex(session => session.name === name)

    updateSessions(draft => {
      draft.splice(session, 1)
    })
  }

  return (
    <SessionsContext.Provider
      value={{
        sessions,
        register,
        hasSessions,
        unregister
      }}
    >
      {children}
    </SessionsContext.Provider>
  )
}

export default SessionsProvider
export const SessionsContext = createContext<SessionsProps>({} as SessionsProps)
